/**
 * `@ocap/client/legacy` — protobuf-encoding back-compat client.
 *
 * For transitional coverage: blocklets still pinning legacy chain nodes or
 * the dual-encoding e2e matrix (`OCAP_E2E_ENCODING=protobuf`). New code MUST
 * import the default `@ocap/client` entry, which is CBOR-only and keeps
 * `google-protobuf` + every `*_pb.js` out of the bundle (see README §4.7 /
 * §4.10 and `tools/bundle-size-check/`).
 *
 * This file re-invokes `createExtensionMethods` from `./extension` with a
 * protobuf-wired dependency bundle. All tx bytes and address derivations
 * go through the protobuf path; `this.txEncoding` is set to `'protobuf'`
 * for observability so chain-side e2e fixtures can assert coverage.
 */
const EventEmitter = require('node:events');
const GraphQLClientBase = require('./base');
const { createExtensionMethods, defaultDeps } = require('./extension');
const { install: installSubscribe } = require('./subscribe');

const { encodeTx, decodeTx } = require('@ocap/message/protobuf');
const { preMintFromFactory: preMintFromFactoryServer } = require('@ocap/asset/mint/server');
const {
  toAssetAddress,
  toFactoryAddress,
  toTokenAddress,
  toTokenFactoryAddress,
  toRollupAddress,
} = require('@arcblock/did-util');

// Pre-bind the dispatch argument so the injected helpers match the
// single-arg shape that `extension.js` calls (the CBOR path has no
// `encoding` parameter). Object.assign instead of spread because the
// babel toolchain here targets node 8 and `babel-preset-env@1` rejects
// object rest spread; see package.json#devDependencies.
const legacyDeps = Object.assign({}, defaultDeps, {
  encodeTx: encodeTx,
  decodeTx: decodeTx,
  preMintFromFactory: function preMintFromFactoryLegacy(opts) {
    return preMintFromFactoryServer(Object.assign({}, opts, { encoding: 'protobuf' }));
  },
  toAssetAddress: function toAssetAddressLegacy(itx) {
    return toAssetAddress(itx, 'protobuf');
  },
  toFactoryAddress: function toFactoryAddressLegacy(itx) {
    return toFactoryAddress(itx, 'protobuf');
  },
  toTokenAddress: function toTokenAddressLegacy(itx) {
    return toTokenAddress(itx, 'protobuf');
  },
  toTokenFactoryAddress: function toTokenFactoryAddressLegacy(itx) {
    return toTokenFactoryAddress(itx, 'protobuf');
  },
  toRollupAddress: function toRollupAddressLegacy(itx) {
    return toRollupAddress(itx, 'protobuf');
  },
});

class GraphQLClientLegacy extends GraphQLClientBase {
  constructor(endpoint, autoInit = true) {
    super(endpoint);
    this.txEncoding = 'protobuf';
    createExtensionMethods(this, legacyDeps);
    installSubscribe(this);

    if (autoInit) {
      this.getContext().catch((err) => {
        console.warn('failed to warmup context', err.message);
      });
    }
  }

  _getSocketOptions() {
    return {};
  }

  _getEventImplementation() {
    return EventEmitter;
  }
}

module.exports = GraphQLClientLegacy;
